import { injectable } from 'tsyringe';
import { OWGamesEvents, OWGamesEventsDelegate } from '../../odk-ts';
import { DelegateProvider } from '../../shared/interfaces/delegate-provider.interface';
import { FunctionPropertyNames } from '../../shared/types';

export const kDITGameEventsListener = 'ow-game-events-listener-service';

// -----------------------------------------------------------------------------
@injectable()
export class OwGameEventsWrapper
  implements OWGamesEventsDelegate, DelegateProvider<OWGamesEventsDelegate>
{
  private gameEventsService: OWGamesEvents;
  private listeners: Set<OWGamesEventsDelegate>;

  // ---------------------------------------------------------------------------
  constructor() {
    this.initialize();
  }

  // ---------------------------------------------------------------------------
  public async start(featuresList: string[] = []) {
    this.gameEventsService = new OWGamesEvents(this, featuresList, 50);
    await this.gameEventsService.start();
  }

  // ---------------------------------------------------------------------------
  public stop() {
    this.gameEventsService?.stop();
    this.gameEventsService = null;
  }

  // ---------------------------------------------------------------------------
  private initialize() {
    this.listeners = new Set<OWGamesEventsDelegate>();
  }

  // ---------------------------------------------------------------------------
  private triggerListenerEvent(
    eventName: FunctionPropertyNames<OWGamesEventsDelegate>,
    param: any,
  ) {
    if (!eventName) {
      return;
    }

    for (const listener of this.listeners) {
      if (!listener[eventName]) {
        continue;
      }

      listener[eventName](param);
    }
  }

  // ---------------------------------------------------------------------------
  public getInfo() {
    return this.gameEventsService?.getInfo();
  }

  // ---------------------------------------------------------------------------
  // OWGamesEventsDelegate
  // ---------------------------------------------------------------------------

  // ---------------------------------------------------------------------------
  onInfoUpdates(info: any) {
    this.triggerListenerEvent('onInfoUpdates', info);
  }

  // ---------------------------------------------------------------------------
  onNewEvents(e: any) {
    this.triggerListenerEvent('onNewEvents', e);
  }

  // ---------------------------------------------------------------------------
  // DelegateProvider<OWGamesEventsDelegate>
  // ---------------------------------------------------------------------------

  // ---------------------------------------------------------------------------

  addListener(listener: OWGamesEventsDelegate) {
    this.listeners.add(listener);
  }

  // ---------------------------------------------------------------------------

  removeListener(listener: OWGamesEventsDelegate) {
    this.listeners.delete(listener);
  }
}
